// Web dictionary loader — the browser counterpart to src/engine/dictionary.ts,
// without the expo-asset / expo-file-system coupling. Fetches the static word
// list and builds the same Trie the native app uses, with the same 2..15 / A-Z
// filter so the two stay in lockstep.
import { Trie } from '../../src/engine/trie';

export async function loadWebDictionary(url = './words.txt'): Promise<Trie> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`words.txt fetch failed: HTTP ${res.status}`);
  const text = await res.text();
  const trie = new Trie();
  const lines = text.split('\n');
  for (let i = 0; i < lines.length; i++) {
    const w = lines[i].trim().toUpperCase();
    if (w.length >= 2 && w.length <= 15 && /^[A-Z]+$/.test(w)) trie.insert(w);
  }
  if (trie.getWordCount() === 0) throw new Error('word list is empty');
  return trie;
}
